import React from 'react';
import { useTranslation } from 'react-i18next';

const SOCIAL = [
  { key: 'facebook', label: 'Facebook', icon: 'f', color: '#1877f2' },
  { key: 'instagram', label: 'Instagram', icon: '📷', color: '#e4405f' },
  { key: 'twitter', label: 'Twitter', icon: '🐦', color: '#1da1f2' }
];

export default function SocialLinks({ social_media }) {
  const { t } = useTranslation();
  const social = social_media && typeof social_media === 'object' ? social_media : {};
  const links = SOCIAL.filter((s) => social[s.key] && social[s.key].trim());

  if (links.length === 0) return null;

  return (
    <section className="ri-section ri-social" aria-labelledby="ri-social-heading">
      <h2 id="ri-social-heading" className="ri-section-title">
        <span className="ri-section-icon" aria-hidden="true">👋</span>
        {t('restaurant.info.social')}
      </h2>
      <div className="ri-social-grid">
        {links.map(({ key, label, icon, color }) => (
          <a
            key={key}
            href={social[key].trim().startsWith('http') ? social[key] : `https://${social[key]}`}
            target="_blank"
            rel="noopener noreferrer"
            className="ri-social-btn"
            style={{ '--ri-social-color': color }}
            aria-label={label}
          >
            <span className="ri-social-icon" aria-hidden="true">{icon}</span>
            <span className="ri-social-label">{label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
